import { render } from "./tratamiento_datos_personales.vue?vue&type=template&id=fe6ea3b0"
import script from "./tratamiento_datos_personales.vue?vue&type=script&lang=js"
export * from "./tratamiento_datos_personales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__